<section class="sd-hero radius4" *ngIf="heroSrc">
  <img [src]="heroSrc" [alt]="heroAlt" />
</section>

<section class="sd-plans-wrap" id="plans" *ngIf="plans.length">
  <div class="sd-plans-strip" aria-label="Planes servidor dedicado">
    <article class="sd-plan-row" *ngFor="let plan of plans">
      <div class="sd-plan-row__surface">
        <div class="sd-plan-row__grid">
          <div class="sd-plan-row__cell sd-plan-row__cell--brand">
            <span class="sd-plan-row__intel" aria-hidden="true">intel</span>
            <span class="sd-plan-row__xeon" aria-hidden="true">Xeon®</span>
            <span class="sd-plan-row__inside" aria-hidden="true">inside</span>
          </div>
          <div class="sd-plan-row__cell sd-plan-row__cell--model">
            <span class="sd-plan-row__plan-name">{{ plan.name }}</span>
            <span class="sd-plan-row__model">{{ plan.model }}</span>
            <span class="sd-plan-row__cpu">{{ plan.cpuLine }}</span>
          </div>
          <div class="sd-plan-row__cell">
            <span class="sd-plan-row__val">{{ plan.ramLabel }}</span>
            <span class="sd-plan-row__lbl">RAM</span>
          </div>
          <div class="sd-plan-row__cell">
            <span class="sd-plan-row__val">{{ plan.diskLabel }}</span>
            <span class="sd-plan-row__lbl">ESPACIO</span>
          </div>
          <div class="sd-plan-row__cell">
            <span class="sd-plan-row__val">{{ plan.raidLabel }}</span>
            <span class="sd-plan-row__lbl">RAID</span>
          </div>
          <div class="sd-plan-row__cell">
            <span class="sd-plan-row__val">{{ plan.tarjetaLabel }}</span>
            <span class="sd-plan-row__lbl">TARJETA</span>
          </div>
          <div class="sd-plan-row__cell">
            <span class="sd-plan-row__val">{{ plan.traficoLabel }}</span>
            <span class="sd-plan-row__lbl">TRÁFICO</span>
          </div>
          <div class="sd-plan-row__cell">
            <span class="sd-plan-row__val">{{ plan.disponibleLabel }}</span>
            <span class="sd-plan-row__lbl">DISPONIBLE</span>
          </div>
          <div class="sd-plan-row__cell sd-plan-row__cell--plus">
            <button
              type="button"
              class="sd-plan-row__plus"
              [class.sd-plan-row__plus--open]="isPlanDetailsOpen(plan.id)"
              (click)="togglePlanDetails(plan.id)"
              [attr.aria-expanded]="isPlanDetailsOpen(plan.id)"
              [attr.aria-controls]="'sd-plan-panel-' + plan.id"
              [attr.aria-label]="ariaTogglePlan(plan)">
              +
            </button>
          </div>
          <div class="sd-plan-row__cell sd-plan-row__cell--cta">
            <div class="sd-plan-row__price-block">
              <span class="sd-plan-row__mensual">Mensual</span>
              <span class="sd-plan-row__amount"
                >{{ cart.symbol }} {{ plan.monthlyPrice | rackeoCurrency:plan.priceDecimals }}</span
              >
            </div>
            <a
              [href]="cart.buildProductUrl(plan)"
              target="_blank"
              rel="noopener noreferrer"
              class="sd-plan-row__stock-pill"
              [attr.aria-label]="'Pedir ' + plan.name + ' en el carrito'">
              SIN STOCK ›
            </a>
          </div>
        </div>
      </div>
      <section
        class="sd-plan-row__panel"
        *ngIf="isPlanDetailsOpen(plan.id)"
        [@sdPlanPanelExpand]
        [id]="'sd-plan-panel-' + plan.id"
        [attr.aria-label]="'Características de ' + plan.name">
        <div class="sd-plan-row__panel-body">
          <ul class="sd-plan-row__panel-list">
            <li *ngFor="let b of plan.bullets">{{ b }}</li>
          </ul>
          <p class="sd-plan-row__footer-note">{{ plan.footerNote }}</p>
          <div class="sd-plan-row__hardware">
            <img
              [src]="hardwareImageForModel(plan.model)"
              [alt]="hardwareAltForModel(plan.model)"
              loading="lazy"
              width="400"
              height="110" />
          </div>
          <p class="sd-plan-row__panel-cart">
            <a [href]="cart.buildProductUrl(plan)" target="_blank" rel="noopener noreferrer">Pedir en carrito</a>
          </p>
        </div>
      </section>
    </article>
  </div>
</section>

<section class="sd-page-tabs radius4" id="plans_text">
  <div class="tabs-sd-wrap">
    <header class="tabs-sd-head">
      <h1 class="tabs-sd-title">Servidores Dedicados</h1>
      <div class="tabs-sd-toolbar">
        <h2 class="tabs-sd-section-title">{{ tabSectionTitles[activeTab] }}</h2>
        <div class="tabs-sd-pills" role="tablist">
          <button
            *ngFor="let label of tabPills; let i = index"
            type="button"
            role="tab"
            [attr.aria-selected]="activeTab === i"
            [class.is-active]="activeTab === i"
            (click)="setTab(i)">
            {{ label }}
          </button>
        </div>
      </div>
    </header>

    <div class="tabs-sd-body" [ngSwitch]="activeTab">
      <!-- Generales -->
      <div *ngSwitchCase="0" class="tabs-sd-panel sd-panel-gen">
        <div class="sd-gen-layout">
          <div class="sd-gen-hero">
            <img
              [src]="generalesIntroImage"
              alt="Servidores dedicados Rackeo — infraestructura y conectividad"
              class="sd-gen-hero__img"
              loading="lazy" />
          </div>
          <div class="sd-gen-blocks">
            <article class="sd-gen-block" *ngFor="let block of generalesBlocks">
              <div class="sd-gen-block__inner" *ngIf="block.image">
                <img loading="lazy" *ngIf="block.image" [src]="block.image" [alt]="block.title" class="sd-gen-block__ico" />
                <div>
                  <h3>{{ block.title }}</h3>
                  <p *ngFor="let para of block.paragraphs">{{ para }}</p>
                </div>
              </div>
              <div *ngIf="!block.image">
                <h3>{{ block.title }}</h3>
                <p *ngFor="let para of block.paragraphs">{{ para }}</p>
              </div>
            </article>
          </div>
        </div>
      </div>

      <!-- Características -->
      <div *ngSwitchCase="1" class="tabs-sd-panel sd-panel-carac">
        <div class="sd-carac-list">
          <article class="sd-carac-block" *ngFor="let block of caracteristicasBlocks">
            <img [src]="block.image" [alt]="block.title" class="sd-carac-block__img" loading="lazy" />
            <div>
              <h3>{{ block.title }}</h3>
              <p *ngFor="let para of block.paragraphs">{{ para }}</p>
            </div>
          </article>
        </div>
      </div>

      <!-- Soporte -->
      <div *ngSwitchCase="2" class="tabs-sd-panel sd-panel-soporte">
        <div class="sd-table-scroll">
          <table class="sd-support-table">
            <thead>
              <tr>
                <th class="sd-support-corner" scope="col">Niveles de Soporte</th>
                <th *ngFor="let col of supportColumnLabels" scope="col">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of supportRows">
                <th scope="row">
                  {{ row.feature }}
                  <span *ngIf="row.helpText" class="sd-help" [attr.title]="row.helpText">?</span>
                </th>
                <td *ngFor="let cell of row.cells">
                  <img loading="lazy"
                    *ngIf="isTick(cell)"
                    class="sd-cell-ico"
                    src="assets/images/rackeo/servidores-dedicados/ui/tick.png"
                    alt="Sí" />
                  <img loading="lazy"
                    *ngIf="isCross(cell)"
                    class="sd-cell-ico"
                    src="assets/images/rackeo/servidores-dedicados/ui/cross.png"
                    alt="No" />
                  <span *ngIf="!isTick(cell) && !isCross(cell)">{{ cell }}</span>
                </td>
              </tr>
              <tr class="sd-support-price-row">
                <th scope="row">Primer Servidor</th>
                <td *ngFor="let v of supportFirstPrices">
                  Gratis {{ cart.symbol }} {{ v | rackeoCurrency:supportPriceDecimals }} x Mes
                </td>
              </tr>
              <tr class="sd-support-price-row">
                <th scope="row">Servidor Adicional</th>
                <td *ngFor="let v of supportExtraPrices">
                  Gratis {{ cart.symbol }} {{ v | rackeoCurrency:supportPriceDecimals }} x Mes
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Adicionales -->
      <div *ngSwitchCase="3" class="tabs-sd-panel sd-panel-addon">
        <div class="sd-addons">
          <article class="sd-addon" *ngFor="let addon of addOns">
            <h4 class="sd-addon-title">{{ addon.title }}</h4>
            <div class="sd-addon-mid">
              <div class="sd-addon-image">
                <img [src]="addon.image" [alt]="addon.title" loading="lazy" />
              </div>
              <div class="sd-addon-price-block">
                <p *ngIf="showAddonPrice(addon) && addon.price != null" class="sd-addon-price">
                  {{ cart.symbol }} {{ addon.price | rackeoCurrency:addon.priceDecimals }}
                </p>
                <p *ngIf="!showAddonPrice(addon)" class="sd-addon-price sd-addon-price--na">No disponible</p>
                <a
                  href="#sd_como_comprar"
                  class="sd-addon-comprar-btn"
                  (click)="scrollToComoComprar($event)">¿Cómo Comprar?</a>
              </div>
            </div>
            <p class="sd-addon-desc">{{ addon.description }}</p>
            <div *ngIf="addon.benefits?.length" class="sd-addon-benefits">
              <p class="sd-addon-benefits-label">Beneficios</p>
              <ul>
                <li *ngFor="let b of addon.benefits">{{ b }}</li>
              </ul>
            </div>
            <p *ngIf="addon.paymentHint || addon.priceNote" class="sd-addon-footer">
              {{ addon.paymentHint || addon.priceNote }}
            </p>
          </article>
        </div>

        <div class="sd-como-comprar radius4" id="sd_como_comprar" tabindex="-1">
          <img loading="lazy" src="assets/images/rackeo/servidores-dedicados/ui/bubble.png" alt="Guía visual: cómo comprar servidores dedicados y servicios adicionales" class="sd-como-comprar-bubble" />
          <h3>¿CÓMO COMPRAR?</h3>
          <p><strong>EN EL PROCESO DE COMPRA DE CUALQUIER PLAN</strong></p>
          <p>
            Para comprar uno o más productos adicionales, debes hacerlo en el momento proceso de compra ahi podras seleccionar los productos que deseas añadir a tu compra.
          </p>
          <p><strong>SI YA TENGO MI PLAN</strong></p>
          <p>
            Si tu ya compraste tu plan y deseas añadir un producto adicional debes, entrar a tu area de cliente presionar la viñeta mis servicios, seleccionar el plan vigente luego presiona el icono editar, ahi podras elegir el producto adicional que deseas
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<p *ngIf="cart.currencyHint" class="sd-tax-hint">{{ cart.currencyHint }}</p>

<section class="sd-cta-ayuda">
  <app-rackeo-cta-contact></app-rackeo-cta-contact>
</section>
